module.exports = __webpack_public_path__ + "static/media/bi_landing.ffbe58c8.svg";